<template>
  <div class="row">
    <div class="flex md12 xs12">
      <sp-360-panel class="chart-widget tree overflowDisabled" :title="headerText" :tooltipOptions="tooltipOptions"
        :footerComplementar="footerComplementar"
        :footerText="footerText">

        <!-- <multiselect name="showTable" v-validate="'required'" :options="showTableOptions" :searchable="false"
          v-model="showTable" :allow-empty="false" deselect-label="" track-by="atributo" label="label" /> -->

        <va-tabs class="tabPadding" v-model="showTable">
          <va-tab v-for="option in showTableOptions" :key="option.atributo">
            {{ option.label }}
          </va-tab>
        </va-tabs>

        <div v-show="!showTable">
          <multiselect name="atributo" v-validate="'required'" :options="options" :searchable="false" v-model="atributo"
            :allow-empty="false" deselect-label="" @input="atualizaTreeSub" track-by="atributo" label="label"/>
          <grafico-tree :dados="dadosTree" ref="graficoArvore" class="treeContainer"></grafico-tree>
        </div>

        <sp360-data-table v-show="showTable" ref="tabelaPorSubUltimoMes" :apiMode="false"
          :data="dadosTabelaPorSubUltimoMes" :fields="tableFieldsPorSub" :perPage="itemsPerPage"
          :onEachSide="onEachSide" :dataModeFilterableFields="dataModeFilterableFields" :sortFunctions="sortFunctions"
          :footerObj="footerObj" />
      </sp-360-panel>

    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Constantes from '@/utils/ConstantesGlobais'
import CorUtil from '@/utils/CorUtils'
import GraficoTree from '@/components/statistics/charts/GraficoTree'
import Multiselect from 'vue-multiselect'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'

export default {
  name: 'ranking-sub-orgao',
  components: {
    GraficoTree,
    Multiselect,
    Sp360Panel,
    Sp360DataTable,
  },
  props: {
    filtro: {
      type: String,
      required: true,
      validator: value => {
        return ['sub', 'orgao'].includes(value)
      },
    },
    footerText: { type: String, default: '' },
    footerComplementar: { type: String, default: '' },
  },
  data () {
    return {
      selectedTabIndex: 0,

      showTable: 0,

      showTableOptions: [
        {
          atributo: 0,
          label: 'Gráfico',
        },
        {
          atributo: 1,
          label: 'Tabela',
        },
      ],

      dadosTree: [],
      solicitacoes30: {},
      topPorRegiao: {},

      options: [
        {
          atributo: 'recebidas',
          label: 'Recebidas',
        },
        {
          atributo: 'canceladas',
          label: 'Canceladas',
        },
        {
          atributo: 'finalizadas',
          label: 'Finalizadas',
        },
        {
          atributo: 'deferidas',
          label: 'Deferidas',
        },
        {
          atributo: 'indeferidas',
          label: 'Indeferidas',
        },
      ],

      // Atributo inicial a ser mostrado
      atributo: {
        atributo: 'recebidas',
        label: 'Recebidas',
      },

      itemsPerPage: Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SOLICITACOES_POR_ORGAO_ULTIMO_MES,
      dadosTabelaPorSubUltimoMes: [],
      onEachSide: 1,
      sortFunctions: {
        'taxaAbertura': MetodosGlobais.ordenaTabelaParseFloat,
        'finalizadas': MetodosGlobais.ordenaTabelaParseInt,
        'recebidas': MetodosGlobais.ordenaTabelaParseInt,
        'canceladas': MetodosGlobais.ordenaTabelaParseInt,
        'deferidas': MetodosGlobais.ordenaTabelaParseInt,
        'indeferidas': MetodosGlobais.ordenaTabelaParseInt,
      },
      footerObj: {},
    }
  },
  computed: {
    tabSelector: () => {
      return this.showTable
    },

    tooltipOptions: function () {
      let texto = ''

      switch (this.filtro) {
        case 'sub': texto = 'graficos156.tooltipRankingRegiao'
          break
        case 'orgao': texto = 'graficos156.tooltipRankingOrgao'
          break
      }

      return { content: this.$t(texto), placement: 'bottom' }
    },

    headerText: function () {
      switch (this.filtro) {
        case 'sub': return this.$t('graficos156.rankingRegiao')
        case 'orgao': return this.$t('graficos156.rankingOrgao')
      }
    },

    dataModeFilterableFields: function () {
      switch (this.filtro) {
        case 'sub': return ['nome']
        case 'orgao': return ['orgao']
      }
    },

    computedTableFields: function () {
      let objOrgao = [{
        name: 'orgao',
        title: this.$t('graficos156.tableFields.orgao'),
        width: '40%',
      }]

      let objSub = [{
        name: 'nome',
        title: this.$t('graficos156.tableFields.sub'),
        width: '40%',
      }]
      switch (this.filtro) {
        case 'sub': return objSub
        case 'orgao': return objOrgao
      }
    },

    tableFieldsPorSub: function () {
      return [
        ...this.computedTableFields,
        {
          name: 'recebidas',
          sortField: 'recebidas',
          title: this.$t('graficos156.tableFields.recebidas'),
          callback: MetodosGlobais.thousandSeparator,
        },
        {
          name: 'taxaAbertura',
          sortField: 'taxaAbertura',
          title: this.$t('graficos156.tableFields.taxaAbertura'),
        },
        {
          name: 'finalizadas',
          sortField: 'finalizadas',
          title: this.$t('graficos156.tableFields.finalizadas'),
          callback: MetodosGlobais.thousandSeparator,
        },
        {
          name: 'canceladas',
          sortField: 'canceladas',
          title: this.$t('graficos156.tableFields.canceladas'),
          callback: MetodosGlobais.thousandSeparator,
        },
        {
          name: 'deferidas',
          sortField: 'deferidas',
          title: this.$t('graficos156.tableFields.deferidas'),
          callback: MetodosGlobais.thousandSeparator,
        },
        {
          name: 'indeferidas',
          sortField: 'indeferidas',
          title: this.$t('graficos156.tableFields.indeferidas'),
          callback: MetodosGlobais.thousandSeparator,
        },
      ]
    },

    storeURL: function () {
      switch (this.filtro) {
        case 'sub': return 'servicos156/buscarTopPorRegiao'
        case 'orgao': return 'servicos156/buscarTopPorOrgao'
      }
    },

  },
  beforeMount () {
    this.atualizaTreeSub()
      .then(() => {
        this.populateTableSub(this.solicitacoes30[this.atributo.atributo])
      })
  },
  methods: {
    populateTableSub (dados) {
      this.calcularTaxas(dados)

      // this.$set(this.dadosTabelaPorSubUltimoMes, _.orderBy(dados, 'recebidas', ['desc']));
      this.dadosTabelaPorSubUltimoMes = _.orderBy(dados, 'recebidas', ['desc'])

      this.footerObj = this.dadosTabelaPorSubUltimoMes.shift()
      this.footerObj.total = MetodosGlobais.thousandSeparator(this.footerObj.total)
      this.footerObj.finalizadas = MetodosGlobais.thousandSeparator(this.footerObj.finalizadas)
      this.footerObj.recebidas = MetodosGlobais.thousandSeparator(this.footerObj.recebidas)
      this.footerObj.abertas = MetodosGlobais.thousandSeparator(this.footerObj.abertas)
      this.footerObj.estoque = MetodosGlobais.thousandSeparator(this.footerObj.abertas)
      this.footerObj.canceladas = MetodosGlobais.thousandSeparator(this.footerObj.canceladas)
      this.footerObj.deferidas = MetodosGlobais.thousandSeparator(this.footerObj.deferidas)
      this.footerObj.indeferidas = MetodosGlobais.thousandSeparator(this.footerObj.indeferidas)
      // this.$refs.tabelaPorSubUltimoMes.update();
    },
    calcularTaxas (dados) {
      dados.forEach(element => {
        element.taxaAbertura = (element.recebidas / dados[0].recebidas * 100).toFixed(2) + '%'
        element.estoque = element.abertas
      })
    },
    updateDadosUltimoMes (novosDados) {
      this.solicitacoes30 = novosDados
      this.populateTreePorSub(this.solicitacoes30.data, this.atributo)
    },
    populateTreePorSub (dados, atributo) {
      let obj = []
      /// /Shift para remover o "Geral"
      let dadosClone = _.clone(dados)
      dadosClone.shift()

      _.forEach(dadosClone, (sub) => {
        let subClone = {}

        subClone.nome = sub.nome || sub.orgao
        subClone.totalizador = sub[atributo.atributo]

        let services = {}
        _.forEach(sub.servicos, (serv) => {
          services[serv.servico_desc] = serv[atributo.atributo]
        })

        subClone.dados = services

        obj.push(subClone)
      })

      this.$set(this, 'dadosTree', obj)
      this.$refs.graficoArvore.carregamentoInicial(_.cloneDeep(this.dadosTree))
    },
    atualizaTreeSub () {
      // Verifica se o conteúdo já foi salvo, para não ter que repetir requests
      if (this.solicitacoes30[this.atributo.atributo]) {
        this.populateTreePorSub(this.solicitacoes30[this.atributo.atributo], this.atributo)
        return Promise.resolve()
      } else {
        return this.$store.dispatch(this.storeURL, { topReqs: Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST, intervalo: 'ULTIMO_MES', ordenacao: this.atributo.atributo })
          .then((retorno) => {
            this.solicitacoes30[this.atributo.atributo] = retorno.data.data
            this.populateTreePorSub(this.solicitacoes30[this.atributo.atributo], this.atributo)
            return Promise.resolve()
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .treeContainer{
          height: 850px;
  }
  .tabPadding {
    padding-bottom: 20px;
  }
  .overflowDisabled {
    overflow: visible;
  }

</style>
